exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".big-number[data-v-0bbb53ac]{display:inline-block;font-size:0.2rem}\n", ""]);

// exports
